// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"54547a9e","703":"8e802a11","787":"50aed45e"}[chunkId] + ".chunk.js";
};